export class StatutCabinet {
    public  id :number;
	public  date : string;
	public  libelle :string;
	public  statut :number;
}